module.exports = __webpack_public_path__ + "public/adminIcons/manageInquiryIcon.svg?4456d247";